import { Space } from 'antd';
import UtilString from '../../utils/UtilString';

const MySpace = ({
  gap,
  style,
  block,
  children,
  spaceBetween,
  className = UtilString.EMPTY_STRING,
  ...otherProps
}) => {
  return (
    <Space
      {...otherProps}
      style={{
        gap: gap ? gap : 8,
        justifyContent: spaceBetween ? 'space-between' : '',
        ...style,
      }}
      className={`${className} ${block ? 'full_width' : ''}`}
    >
      {children}
    </Space>
  );
};

export default MySpace;
